import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  FaClipboardList,
  FaGavel,
  FaChartLine,
  FaBell,
  FaCog,
  FaWallet,
  FaTimes,
  FaChevronRight
} from 'react-icons/fa';
import axios from 'axios';

function CabinetSidebar({ isOpen, onClose, isMobile }) {
  const location = useLocation();
  const [counts, setCounts] = useState({
    announcements: 0,
    bids: 0,
    notifications: 0
  });

  // Fetch counts
  useEffect(() => {
    fetchCounts();
  }, []);

  const fetchCounts = async () => {
    try {
      const [announcementsRes, bidsRes, notificationsRes] = await Promise.allSettled([
        axios.get('https://api.herracim.az/api/ProductBase/my-products', { withCredentials: true }),
        axios.get('https://api.herracim.az/api/bids/my-bids', { withCredentials: true }),
        axios.get('https://api.herracim.az/api/notifications/unread-count', { withCredentials: true })
      ]);

      setCounts({
        announcements: announcementsRes.status === 'fulfilled' ? announcementsRes.value.data.length : 0,
        bids: bidsRes.status === 'fulfilled' ? bidsRes.value.data.length : 0,
        notifications: notificationsRes.status === 'fulfilled' ? notificationsRes.value.data.unreadCount : 0
      });
    } catch (error) {
      console.error('Counts yükləmə xətası:', error);
    }
  };

  const navItems = [
  {
    icon: FaClipboardList,
    label: 'Hərraclarım',
    path: '/kabinetim',
    exact: true,
    badge: counts.announcements > 0 ? counts.announcements : null
  },
  {
    icon: FaGavel,
    label: 'Hərraclarım',
    path: '/kabinetim/herraclarim',
    badge: null
  },
  {
    icon: FaChartLine,
    label: 'Təkliflərim',
    path: '/kabinetim/tekliflerim',
    badge: counts.bids > 0 ? counts.bids : null
  },
  {
    icon: FaBell,
    label: 'Bildirişlər',
    path: '/kabinetim/bildirislerim',
    badge: counts.notifications > 0 ? counts.notifications : null,
    highlight: counts.notifications > 0
  },
  {
    icon: FaWallet,
    label: 'Balans',
    path: '/kabinetim/balans'
  },
  {
    icon: FaCog,
    label: 'Tənzimləmələr',
    path: '/kabinetim/ayarlar'
  }
];


  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <aside className={`cabinet-sidebar ${isOpen ? 'open' : ''} ${isMobile ? 'mobile' : ''}`}>
        {/* Mobile Header */}
        {isMobile && (
          <div className="cabinet-sidebar__header">
            <h3 className="cabinet-sidebar__header-title">Menyu</h3>
            <button 
              className="cabinet-sidebar__close"
              onClick={onClose}
              aria-label="Menyunu bağla"
            >
              <FaTimes />
            </button>
          </div>
        )}

        {/* Navigation */}
        <nav className="cabinet-sidebar__nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={`cabinet-sidebar__item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              onClick={isMobile ? onClose : undefined}
              end={item.exact}
            >
              <div className="cabinet-sidebar__item-content">
                <item.icon className="cabinet-sidebar__icon" />
                <span className="cabinet-sidebar__label">{item.label}</span>
              </div>
              
              {item.badge !== null && item.badge !== undefined && (
                <span className={`cabinet-sidebar__badge ${item.highlight ? 'highlight' : ''}`}>
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
              
              {!isMobile && isActive(item.path, item.exact) && (
                <FaChevronRight className="cabinet-sidebar__arrow" />
              )}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="cabinet-sidebar__footer">
          <p className="cabinet-sidebar__footer-text">
            © 2024 Herrac.az
          </p>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div 
          className="cabinet-sidebar__overlay"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
    </>
  );
}

export default CabinetSidebar;